enum ParametreGrupEnum {
  KimlikTuru = 1,
  Cinsiyet = 2,
  MedeniHali = 3,
  KanGrubu = 4,
  Meslek = 5,
  OgrenimDurumu = 6,
  Ulkeler = 7,
  ServisTip = 8,
  TestGruplari = 9,
  BransGruplari = 10,
  RolTipleri = 11,
  PersonelTurleri = 12,
  PersonelCalismaDurumu = 13,
  HastaServisTipi = 14,
  HastaServisGirisTipi = 15,
  HastaServisIslemDurumu = 16,
  KayitTuru = 17,
  Oncelik = 18,
  OdemeTipi = 19,
  Yakinlik = 20,
  YetkiTipi = 21,
  IslemDurumu = 22,
  DuyuruTipleri = 23,
  HastaCikisSekilleri = 24,
  YetkiVtysGruplari = 25,
  FaturaTipi = 30,
  MalzemeGrup = 31,
  IslemTipi = 32,
  IslemGrup = 33,
  FaturaDurum = 34,
  KimlikIletisimTercihleri = 35,
  IndirimNedeni = 36,
  RaporTipleri = 37,
  UyariDurumlari = 38,
  ZorunlulukDurumlari = 39,
  ParaBirimleri = 40,
  Endikasyonlar = 41,
  TanimIptalNedenleri = 42,
  UcretHesaplamaFormulu = 43,
  KurumSozlesmeTurleri = 44,
  IslemIptalNedenleri = 66,
  EntegrasyonPosCihazTipleri = 200,
  EntegrasyonOrganizasyonEntegrasyonAyarlari = 201,
  StokKaynaklari = 13999,
  StokTurleri = 14000,
  StokGruplari = 14001,
  StokIlacReceteTurleri = 14002,
  StokKullanimSekilleri = 14003,
  StokOlcuBirimleri = 14004,
  StokSaklamaKosullari = 14005,
  StokRiskGruplari = 14006,
  StokRecetePeriyodBirimleri = 14007,
  StokReceteDozBirimleri = 14008,
  StokGirisTipleri = 14009,
  StokCikisTipleri = 14010,
  StokTalepTipleri = 14011,
  StokIadeTipleri = 14012,
  StokHastaTabela = 14013,
  StokIptalNedenleri = 14014,
  StokTalepRedNedenleri = 14015,
  StokTalepOlcuBirimYontem = 14017,
  FaturaIptalNedeni = 15000,
  FaturaTuru = 15001,
  KurumKdvDurumu = 15002,
  FaturaHakedisIptalNedenleri = 15003,
  DoktorHakedisIptalNedenleri = 15004,
  MuayeneRandevuAksiyonlari = 15010,
  MuayeneRandevuDurumlari = 15020,
  DisBarkodIptalNedeni = 15030,
  HastaDokumanTurleri = 16000,
  HastaReceteTurleri = 17000,
  HastaReceteKullanımPeriyot = 17001,
  HastaReceteKullanımSekli = 17002,
  DepoTipi = 45,
  TaniTipi = 47,
  OrderGruplari = 50,
  KonsultasyonTipleri = 51,
  PatolojiYerlesimYeri = 52,
  PatolojiDokununTemelOzelliği = 53,
  PatolojiAlinmaSekli = 54,
  ASASkoru = 55,
  AmeliyatAcilElektif = 56,
  YatisAciliyet = 48,
  YatisDurum = 49,
  PatolojiMateryalTanimlari = 59,
  ProtokolTurleri = 58,
  KargoKuryeIptalNedenleri = 18000,
  MailTipleri = 60,
  LaboratuvarPatolojiNumuneDurumları = 62,
  ArsivlemeIptalNedenleri = 19000,
  MuhasebeHesapPlanHesapTurleri = 300,
  MuhasebeHesapPlanBakiyeDurumlari = 301,
  Gunler = 19001,
  VeriTip = 19002,
  MuhasebeIslemFisTurleri = 302,
  MuhasebeIşlemIptalNedenleri = 303,
  PatolojiIptalNedenleri = 20000,
  PatolojiRedNedenleri = 61,
  PatolojiRedGeriAlmaNedenleri = 68,
  RadyolojiRedNedenleri = 69,
  GenelMesajTurleri = 400,
  PatolojiPreperatDurumlari = 70,
  HastaTetkikleriIptalNedenleri = 30000,
  SonucIzlemeOnayDurumu = 5550,
  SonucIzlemeRaporIndirmeDurumu = 5560,
  TetkikTanimKDVOranlari = 71,
  TarifeTanimlari = 40000,
  ServisIslemAktarmaTipleri = 72,
  SigortaMudurlugu = 80,
  IslemTipTanimlari = 73,
  OrderDurumlari = 14050,
  OrderIlacUygulamaDurumlari = 14060,
  OrderIlacSecimTurleri = 14070,
  IlacMalzemeFiyatYonetimi = 14080,
  BransServisVeriler = 46,
  RezervBarkodIptalNedenleri = 500,
  KurumBonusYontem = 6000,
  GonderimSureYontem = 76,
  GonderimYontem = 77,
  UyariGrubu = 600,
  HastaUyariGrubu = 601,
  UyariTipi = 602,
  TarifeIstisnaKotaUyariDurumlari = 603,
};
export default ParametreGrupEnum;
